// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Xn3aC","layoutColumn":"styles_layoutColumn__eJgBT"};